import * as types from './pointsActionTypes';

const initialState = {
    totalPoints: 0,
    currentPoints : 0,
    badgeToAttribute : [],
    isInit: false
};

const updatePoints = (state, action) => {
    const { currentPoints, totalPoints } = action;
    return {
        ...state,
        isInit: true,
        currentPoints,
        totalPoints
    }
}

const attributeBadges = (state, action) => {
    const { badgeToAttribute } = action;
    return {
        ...state,
        badgeToAttribute
    }
}

const destroyPointsListeners = (state, action) => {
    return {
        ...state, 
        totalPoints: 0,
        currentPoints : 0,
        badgeToAttribute : [],
        isInit: false
    };
}


export const points = (state = initialState, action) => {
    switch(action.type) {
        case types.UPDATE_POINTS:       return updatePoints(state, action);
        case types.ATTRIBUTE_BADGES:    return attributeBadges(state, action);
        case types.DESTROY_POINTS:      return destroyPointsListeners(state, action);
        default: return state;
    }
}

export default points;


// WEBPACK FOOTER //
// ./src/components/Points/pointsReducers.js